module.exports = __webpack_public_path__ + "static/media/Colette Single Bed Base - 90x200 cm.034ae397.jpg";